<template>
  <v-app class="app-tabela">
    <div class="box" style="margin-top: 0px">
      <v-card class="tabela">
        <!-- <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Nome da equipe"
            class="input-bottom"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title> -->
        <v-data-table
          @pagination="getPagination"
          :page="currentPage"
          :footer-props="{
            itemsPerPageText: '',
            'items-per-page-options': [15],
            'disable-items-per-page': true,
          }"
          :loading="loading"
          loading-text="Carregando, Por favor espere"
          :headers="headers"
          :items="indexedItems"
          :search="search"
          item-key="id"
          class="elevation-1"
        >
          <!-- <template #footer.prepend>
                    <v-spacer />
                  </template> -->
          <template v-slot:item.dt_ultimo_registro="{ item }">
            {{ formatDate(item.dt_ultimo_registro) }}
          </template>
          <template v-slot:item.dt_sinc="{ item }">
            {{ formatDate(item.dt_sinc) }}
          </template>

          <template v-slot:[`footer.page-text`]="items">
            <!-- <div class="info-table-item tabela-esus-pec">
              <p class="fonte">
                <b>Fonte:</b> e-SUS PEC, {{ ultimaAtualizacao }}
              </p>
            </div> -->
            <span class="paginacao"
              >{{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }} registros</span
            >
          </template>
          <template v-slot:progress>
            <v-progress-linear
              color="blue"
              :height="10"
              indeterminate
            ></v-progress-linear>
          </template>
          <template v-slot:no-data>
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada.</b>
            </div>
          </template>
          <template v-slot:no-results style="padding: 0px">
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada.</b>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-app>
</template>

<script>
import utils from '@/mixins/utils.js'

export default {
  components: {},
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: '',
    },
    ultimaAtualizacao: {
      type: String,
      default: '',
    },
  },
  mixins: [utils],
  data() {
    return {
      search: '',
      headers: [
        {
          text: 'Tabela sincronizada',
          align: 'start',
          filterable: true,
          value: 'ds_tabela_sincronizada',
        },
        {
          text: 'Último registro',
          align: 'start',
          filterable: false,
          value: 'dt_ultimo_registro',
        },
        {
          text: 'Quantidade registros',
          align: 'start',
          filterable: true,
          value: 'qtd_registros',
        },
        {
          text: 'Sincronização',
          align: 'start',
          filterable: false,
          value: 'dt_sinc',
        },
      ],
      currentPage: 1,
    }
  },
  computed: {
    indexedItems() {
      return this.cadastros.map((item, index) => ({
        id: index,
        ...item,
      }))
    },
  },
  methods: {
    getPagination(options) {
      this.currentPage = options.page
    },
  },
}
</script>

<style></style>
